import { IThemeProps } from "component/theme";
import styled from "styled-components";

export const StyledMydevicesDetail = styled.div`
  ${({theme, customView}: IThemeProps & { customView?: any }) => `
    .state {
      position: relative;
      margin: ${theme.uptimeSpace[5]}px ${5*theme.uptimeSpace[5]}px ${theme.uptimeSpace[0]}px;
      padding-left: ${theme.uptimeSpace[4]}px;
      text-transform: uppercase;
      color: ${theme.uptimeColors.deviceCardEyebrow.active.background};
      font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
      font-weight: 700;
      
      &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 4px;
        height: 4px;
        margin-top: -${theme.uptimeSpace[1]}px;
        background-color: ${theme.uptimeColors.deviceCardEyebrow.active.background};
        border-radius: 50%;
      }
    }
    .image-block {
      position: relative;
      > img {
        display: block;
        margin: ${theme.uptimeSpace[0]}px auto;
        width: 100%;
        max-width: 250px;
      }
    }
    .info-device {
      padding: ${theme.uptimeSpace[12]}px;
      .eyebrow {
        margin-bottom: ${theme.uptimeSpace[8]}px;
      }
      .option, .value {
        color: ${theme.uptimeColors.grayScales.darkGray};
      }
      .option {
        margin: ${theme.uptimeSpace[0]}px;
        text-transform: uppercase;
      }
      .ttl-device {
        margin: ${theme.uptimeSpace[4]}px ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[0]}px;
        color: ${theme.uptimeColors.grayScales.black};
        font-size: ${customView?.tabletView ? 2.5*theme.uptimeFontSizes.desktop.fz1 : theme.uptimeFontSizes.desktop.fz4}px;
        font-weight: 700;
        line-height: initial;
      }
      .content {
        margin: ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[0]}px;

        list-style-type: none;
        li {
          padding: ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[0]}px;
          display: flex;
          font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
          line-height: 1.2 !important;
          align-items: center;
          svg {
            color: ${theme.uptimeColors.grayScales.black};
            font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
            display: block;
          }
          .value{
            word-break: break-word;
          }
        }
        .icon-computer {width: 14px;}
        .label {
          margin-left: ${theme.uptimeSpace[2]}px;
          font-weight: 700;
          padding-right: ${theme.uptimeSpace[2]}px;
          color: ${theme.uptimeColors.grayScales.black};
          white-space: nowrap;
          text-transform: capitalize;
        }
      }
    }
    .detail-block {
      padding: ${theme.uptimeSpace[12]}px;
      border-top: solid 1px ${theme.uptimeColors.grayScales.darkGray};
      h4 {
        min-height: auto;
        margin: ${theme.uptimeSpace[0]}px;
        color: ${theme.uptimeColors.grayScales.black};
        font-size: ${theme.uptimeFontSizes.desktop.fz6}px;
        font-weight: 700;
      }
      .description-content {
        margin-top: ${theme.uptimeSpace[5]}px;
        color: ${theme.uptimeColors.grayScales.black};
        font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
        line-height: 1.5;
      }
    }

    .list-link {
      ul {
        margin: ${theme.uptimeSpace[0]}px;
        padding: ${theme.uptimeSpace[0]}px;
        list-style-type: none;
        text-align: center;
      }
      li {
        display: inline-block;
        vertical-align: middle;
        margin: ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[5]}px;
        button {   
          font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
          padding: ${theme.uptimeSpace[0]}px;
          min-width: auto;
          text-transform: capitalize;
        }
      }
      .item-link {
        cursor: pointer;
        color: ${theme.uptimeColors.grayScales.black};
        font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
        &:hover {
          color: ${theme.uptimeColors.grayScales.darkGray};
          background-color: transparent;
          text-decoration-line: underline;
        }
      }     
    }
    .devices-detail-horizontal-inner {
      display: flex;
      .info-device {
        min-height: 184px;
        flex-direction: ${customView?.mobileView ? "row" : "column"};
        padding: ${theme.uptimeSpace[0]}px;
        flex: 1;
        .content{
          padding: ${theme.uptimeSpace[0]}px;
        }

        .image-block {
          > img {
            width: 200px;
          }
        }
      }
      .info-device-detail {
        flex: 1;
        .detail-block{
          border: none;
        }
      }
    }
    .info-device-horizontal {
      display: flex;
      .info-device-thumbnail {
        flex: 1;
      }
      .content {
        flex: 1;
      }
    }
    .btn-copy {
      border: 0;
      background-color: transparent;
      &:hover {cursor: pointer;}
    }
    .copy-txt {
      width: 0;
      height: 0;
      padding: ${theme.uptimeSpace[0]}px;
      opacity: 0;
      visibility: hidden;
    }

    @media (max-width: $md-1-breakpoints) {
      .item-devices .devices-detail-horizontal-inner{
        display: block;
        .info-device-horizontal{
          display: block;
        }
      }
    }
  `}
` 